export default __webpack_public_path__ + "static/media/tete4.87a692ab.png";